export default "__VITE_ASSET__Du0G9hDp__"